import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress as MuiCircularProgress,
  IconButton,
  Tooltip,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Gift } from "lucide-react";
import axios from "utils/axios";
import { headerIconButtonSx, V2 } from "layout/Dashboard/Header/headerV2Tokens";

export default function GlobalPointsDisplay() {
  const navigate = useNavigate();
  const [globalData, setGlobalData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGlobalPoints();
  }, []);

  const fetchGlobalPoints = async () => {
    try {
      const response = await axios.get("/api/gamification/dashboard-data");
      if (response.data?.global) {
        setGlobalData(response.data.global);
      }
    } catch (err) {
      console.error("Error fetching global points:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    navigate("/profile/account/dashboard");
  };

  if (loading || !globalData) {
    return null;
  }

  const { points, progress } = globalData;
  const progressPercentage = progress?.progress_percentage || 0;

  // Custom tooltip content with progress circle
  const tooltipContent = (
    <Stack spacing={1} alignItems="center" sx={{ p: 1 }}>
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        {/* Background Circle */}
        <MuiCircularProgress
          variant="determinate"
          value={100}
          size={60}
          thickness={4}
          sx={{
            color: "rgba(255,255,255,0.2)",
            position: "absolute",
            left: 0,
            top: 0,
          }}
        />
        {/* Progress Circle */}
        <MuiCircularProgress
          variant="determinate"
          value={progressPercentage}
          size={60}
          thickness={4}
          sx={{
            color: V2.accent,
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />
        {/* Points Display */}
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" fontWeight={700} color="white">
            {points}
          </Typography>
          <Typography
            variant="caption"
            color="white"
            sx={{ fontSize: "0.65rem" }}
          >
            points
          </Typography>
        </Box>
      </Box>
      <Typography variant="caption" color="white">
        Voir le Tableau de Bord
      </Typography>
    </Stack>
  );

  return (
    <Tooltip title={tooltipContent} arrow>
      <IconButton onClick={handleClick} sx={headerIconButtonSx(false)}>
        <Gift strokeWidth={1.7} color={V2.ink} size={20} />
      </IconButton>
    </Tooltip>
  );
}
